export const ALL_CATEGORY_ID = '661e6a163f4e5c0bbff1b031'
